export default __webpack_public_path__ + "static/media/logo-light.b905614d.svg";